import * as TYPES from '../../store/types'

const state = {
  inquiries: [],
  inquiries_metadata: {},
  readOnly: false,
}

/* eslint-disable no-param-reassign */
const mutations = {
  [TYPES.INQUIRIES_SET_DATA](st, obj) {
    if (obj.inquiries) {
      st.inquiries = obj.inquiries
    }
    if (obj.metadata) {
      st.inquiries_metadata = obj.metadata
    }

    st.readOnly = !!obj.readOnly
  },
}

const actions = {
  inquiriesSetData({ commit }, obj) {
    commit(TYPES.INQUIRIES_SET_DATA, obj)
  },
}

const module = {
  state,
  mutations,
  actions,
}

export default { module }
